import React, { useState } from 'react';
import DraggableDeckCard from './DraggableDeckCard';

const ExpandableDeckPanel = ({ 
  title, 
  cards, 
  from, 
  isExpanded, 
  onToggle,
  onCardDragStart,
  isDragging,
  // Card info modal handlers
  setSelectedCard,
  setShowCardInfoModal,
  globalIsDragging
}) => {
  return (
    <div 
      className="expandable-deck-panel"
      style={{
        zIndex: isDragging ? -5 : 'auto',
        transition: 'z-index 0.2s ease'
      }}
    >
              <div 
          className="expandable-deck-header"
          onClick={onToggle}
          style={{
            backgroundColor: '#2c2c2c',
            color: 'white',
            padding: '8px 12px',
            cursor: 'pointer',
            borderRadius: '4px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: isExpanded ? '8px' : '0',
            opacity: isDragging ? 0.1 : 1,
            transition: 'opacity 0.2s ease',
            zIndex: isDragging ? -5 : 'auto'
          }}
        >
        <span style={{ fontWeight: 'bold' }}>{title} ({cards.length})</span>
        <span 
          style={{ 
            fontSize: '18px', 
            cursor: 'pointer',
            padding: '2px 6px',
            borderRadius: '3px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }}
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        >
          ✕
        </span>
      </div>
      
      {isExpanded && (
        <div 
          className="expandable-deck-content"
          style={{
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            borderRadius: '4px',
            padding: '8px',
            maxHeight: '200px',
            overflowY: 'auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '4px',
            opacity: isDragging ? 0.1 : 1,
            transition: 'opacity 0.2s ease',
            pointerEvents: isDragging ? 'none' : 'auto',
            zIndex: isDragging ? -5 : 'auto'
          }}
        >
                                 {cards.map((card, idx) => (
              <DraggableDeckCard
                key={`panel-card-${card.id}-${idx}`} // Use card ID + index for truly unique React keys
                // This prevents duplicate key warnings when shuffling decks with duplicate cards
                card={card}
                index={idx}
                from={from}
                onDragStart={() => {
                  console.log('Card drag started from panel, making transparent');
                  // Prevent immediate panel closing on desktop
                  setTimeout(() => {
                    onCardDragStart && onCardDragStart();
                  }, 50);
                }}
                setSelectedCard={setSelectedCard}
                setShowCardInfoModal={setShowCardInfoModal}
                globalIsDragging={globalIsDragging}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export default ExpandableDeckPanel; 